module.exports = __webpack_public_path__ + "static/media/rectus_abdominis_weak.c77f413f.png";